import cmsApi from '@src/services/cms-api';

/*
内功崛起 刷怪增伤  CMS-ID：11504
• 界面改造 CMS-ID：11516
• 修行指引 CMS-ID：11519
• 决战烽火 CMS-ID：11517
• 帮会宝箱 CMS-ID：11520
• 新服礼卡 CMS-ID：11521
• 每日宝箱 CMS-ID：11522
• 玩法焕新 体验进阶  CMS-ID：11518
• 武魂堂 CMS-ID：11523
• 武当 CMS-ID：11524
• 少林 CMS-ID：11525
• 逍遥 CMS-ID：11526
*/
export const getCmsData = () => {
  return cmsApi
    .getArticleList({
      categoryId: 7845,
      pageNum: 1,
      pageSize: 999,
      moreInfo: 1
    })
    .then(res => {
      return {
        11504: res.list.find(item => +item.articleId === 11504).content,
        11516: res.list.find(item => +item.articleId === 11516).content,
        11519: res.list.find(item => +item.articleId === 11519).content,
        11517: res.list.find(item => +item.articleId === 11517).content,
        11520: res.list.find(item => +item.articleId === 11520).content,
        11521: res.list.find(item => +item.articleId === 11521).content,
        11522: res.list.find(item => +item.articleId === 11522).content,
        11518: res.list.find(item => +item.articleId === 11518).content,
        11523: res.list.find(item => +item.articleId === 11523).content,
        11524: res.list.find(item => +item.articleId === 11524).content,
        11525: res.list.find(item => +item.articleId === 11525).content,
        11526: res.list.find(item => +item.articleId === 11526).content
      };
    });
  // return cmsApi.makeCmsCustomConfigRequest('//jx.xoyo.com/api/config/tag/', 'zt/202603_zlp_nzjq');
};
